import { useEffect, useState } from 'react';
import './LeadTodosContent.css';
import { getLead } from '../../utilities/api/leads';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import NewLeadTodo from '../../components/NewLeadTodo/NewLeadTodo';
import TodoItem from '../../components/TodoItem/TodoItem';
import DeleteLeadTodo from '../../components/DeleteLeadTodo/DeleteLeadTodo';
import UpdateLeadTodo from '../../components/UpdateLeadTodo/UpdateLeadTodo';
import { useNavigate, useParams } from 'react-router-dom';

export default function LeadTodosContent({user, isMobile, toggleNotifications }) {
    const [loading, setLoading] = useState(false)
    const [lead, setLead] = useState(null)
    const [todos, setTodos] = useState([])
    const [sortOrder, setSortOrder] = useState('desc')
    const [sortHeader, setSortHeader] = useState('createdAt')
    const params = useParams()
    const navigate = useNavigate()

    const handleTableHeaderClick = (evt) => {
        const header = evt.target.id;
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
        setSortHeader(header);
        setSortOrder(newSortOrder);

        let sortedTodos = [...lead.todos]
        sortedTodos.sort((a, b) => {
        if (newSortOrder === 'asc') {
            return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) > (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
        } else {
            return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) < (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
        }
        });
        setTodos(sortedTodos)
    }

    const handleBackButton = () => {
        navigate(-1)
    }

    const getLeadItem = async (leadID) => {
        setLoading(true)
        try {
            const res = await getLead(leadID)
            setLead(res)
            setTodos(res.todos.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1))
        } catch (err) {
            console.log(err)
        }
        setLoading(false)
    }

    useEffect(() => {
        getLeadItem(params.leadID)
        // eslint-disable-next-line
    },[])

    if (!['admin', 'manager'].includes(user.userType)) {
        return (
            <div className='LeadTodosContent unauthorized'>
                <strong className='text-center'>You are not authorized to view this page!</strong>
            </div>
        )
    }

    if (loading) {
        return (
            <div className='LeadTodosContent loading'>
                <div className="spinner-border" role="status"></div>
            </div>
        )
    }

    if (!lead) {
        return (
            <div className='LeadTodos noLead'>
                <strong>No Lead Found</strong>
            </div>
        )
    }


  return (
    <div className='LeadTodosContent'>
        <button className='backButton' onClick={handleBackButton}>
            <svg width="8" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 13L1 7L7 1" stroke="#1A5E9B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>&nbsp;&nbsp;Back</span>
        </button>
        <div className='leadTodosHeadingContainer'>
            <div className='section1'>
                <div className='svg'>
                    <svg width="30" height="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                        <path d="M1.6665 14.1666L9.99984 18.3333L18.3332 14.1666M1.6665 9.99996L9.99984 14.1666L18.3332 9.99996M9.99984 1.66663L1.6665 5.83329L9.99984 9.99996L18.3332 5.83329L9.99984 1.66663Z" stroke="#1A5E9B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>                    
                    </svg>
                </div>
                <div className='title'>
                    <div className='name'>{capitalizeFirstLetter(lead.leadName)}</div>
                    <div className='email'>
                        <span>
                            <svg width="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.3333 5C18.3333 4.08334 17.5833 3.33334 16.6666 3.33334H3.33329C2.41663 3.33334 1.66663 4.08334 1.66663 5M18.3333 5V15C18.3333 15.9167 17.5833 16.6667 16.6666 16.6667H3.33329C2.41663 16.6667 1.66663 15.9167 1.66663 15V5M18.3333 5L9.99996 10.8333L1.66663 5" stroke="#667085" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </span>
                        <span>
                            &nbsp;{lead.email}
                        </span>
                    </div>
                </div>
            </div>
            <div className='section2'>
                { ['admin', 'manager'].includes(user.userType) &&
                <>
                <div className='createTodoItem'>
                    <button className='createTodoButton' data-bs-toggle="modal" data-bs-target={`#createTodoItemModal`} title='Create New Todo'>
                        <svg width="20" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="38" height="38" rx="10" fill="#FFFFFF" opacity='0.05'/>
                            <path d="M19 11V27V11ZM27 19H11H27Z" fill="#2173F0"/>
                            <path d="M19 11V27M27 19H11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>
                            &nbsp;&nbsp;Add Todo Item
                        </span>
                    </button>
                    <NewLeadTodo user={user} lead={lead} getLeadItem={getLeadItem} toggleNotifications={toggleNotifications} />
                </div>
                </>
                }
            </div>
        </div>
        <div className='leadTodosMainSection'>
            <div className='header'>
                <div className='title'>
                    To-do List
                </div>
                {/* <div className='filter'>
                    filter
                </div> */}
            </div>
            <div className='todosTable'>
                <table className=''>
                    <thead>
                    <tr>
                        <th id='title' onClick={handleTableHeaderClick} className='todoTitle' title='Click to sort by title'>
                            <div className='tableHeaderWithArrow'><div>Title&nbsp;&nbsp;</div>
                            { sortHeader==='title'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                            }
                            </div>
                        </th>
                        <th id='description'className='description'>Description</th>
                        <th id='createdAt' onClick={handleTableHeaderClick} title='Click to sort by creation date'>
                            <div className='tableHeaderWithArrow'><div>Creation Date&nbsp;&nbsp;</div>
                            { sortHeader==='createdAt'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                            }
                            </div>
                        </th>
                        <th id='createdBy' onClick={handleTableHeaderClick} title='Click to sort by creator'>
                            <div className='tableHeaderWithArrow'><div>Creator&nbsp;&nbsp;</div>
                            { sortHeader==='createdBy'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                            }
                            </div>
                        </th>
                        <th id='assignedTo' onClick={handleTableHeaderClick} title='Click to sort by assignee'>
                            <div className='tableHeaderWithArrow'><div>Assignee&nbsp;&nbsp;</div>
                            { sortHeader==='assignedTo'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                            }
                            </div>
                        </th>
                        <th id='priority' onClick={handleTableHeaderClick} title='Click to sort by priority'>
                            <div className='tableHeaderWithArrow'><div>Priority&nbsp;&nbsp;</div>
                            { sortHeader==='priority'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                            }
                            </div>
                        </th>
                        <th id='deadline' onClick={handleTableHeaderClick} title='Click to sort by deadline'>
                            <div className='tableHeaderWithArrow'><div>Deadline&nbsp;&nbsp;</div>
                            { sortHeader==='deadline'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                            }
                            </div>
                        </th>
                        <th id='status' onClick={handleTableHeaderClick} title='Click to sort by status'>
                            <div className='tableHeaderWithArrow'><div>Status&nbsp;&nbsp;</div>
                            { sortHeader==='status'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                            }
                            </div>
                        </th>
                        <th id='actions' className='actions'>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {todos.map(todo => (
                        <TodoItem user={user} key={todo._id} todo={todo} lead={lead} isMobile={isMobile} getLeadItem={getLeadItem} toggleNotifications={toggleNotifications} />
                    ))}
                    </tbody>
                </table>
                <div>
                { todos.map(todo => (
                    <div key={todo._id}>
                        <UpdateLeadTodo user={user} lead={lead} todo={todo} getLeadItem={getLeadItem} toggleNotifications={toggleNotifications} />
                        <DeleteLeadTodo user={user} lead={lead} todo={todo} getLeadItem={getLeadItem} toggleNotifications={toggleNotifications} />
                    </div>
                ))}
                </div>
            </div>
            <div className='footer'>
                <div>
                    page count
                </div>
                <div>
                    toggle
                </div>
            </div>
        </div>
    </div>
  )
}
